// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetEvents = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        resident_events: []

    }),

    /*
	**  Methods
    */
    
    methods: {

        getEventsHandler: function(property_id, resident_id, limit) {

            try {

                /*
                **  Reset the prop
                **  @prop: @here
                */

                this.resident_events = [];

                /*
                **  Get the events
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(property_id).collection('residents').doc(resident_id).collection('events').limit(limit).orderBy('meta.created_at', 'desc').get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    snapshot.forEach(doc => {

                        this.resident_events.push(doc.data());

                    });

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get Property Resident Events from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Resident',
                        uid: 'COuX5dquqiHBV0RTTJOP',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query for a Property Resident Events from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Resident',
                    uid: 'vHVOot2ZtPvSkncV1h2H',
                    error: e
                });

            }

        }

    }

}